import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<path class="DetailedIcon__secondary-color-fill" d="M30,2A11,11,0,0,0,19,13V37a3,3,0,0,0,3,3H38a3,3,0,0,0,3-3V13A11,11,0,0,0,30,2Z"/><path class="DetailedIcon__foreground-color-fill" d="M37.8,11.153H10.766V7.2a1.289,1.289,0,0,0-2.572,0v3.953H4.2a1.289,1.289,0,0,0,0,2.571H8.194V40.8a1.289,1.289,0,0,0,2.572,0V13.724h5.143V16.3a2.58,2.58,0,0,0-2.572,2.572V30.438a2.579,2.579,0,0,0,2.572,2.572h18a2.579,2.579,0,0,0,2.571-2.572V18.867A2.579,2.579,0,0,0,33.909,16.3V13.724H37.8a1.289,1.289,0,0,0,0-2.571ZM33.909,30.438h-18V18.867h18ZM31.337,16.3H18.48V13.724H31.337Z"/><path class="DetailedIcon__accent-color-fill" d="M25.992,22.14l-2.327,1.851-.463-.475a1.291,1.291,0,0,0-1.826,1.825l1.286,1.286a1.317,1.317,0,0,0,.913.373,1.238,1.238,0,0,0,.8-.283l3.214-2.571a1.281,1.281,0,1,0-1.594-2.006Z"/>';
export var ForSaleSignSVG = function ForSaleSignSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ForSaleSignSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(ForSaleSignSVG);